import { useQuery } from 'react-query';

import { DataRoomSummary, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomSummaryQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.Summary(guid),
		() => AxiosUtils.getResponseData<DataRoomSummary>(api.get(CerebroApiEndpoints.DataRooms.Summary(guid))),
		{ enabled: guid !== undefined }
	);
}
